import request from '@/utils/request'

// 周报列表--yhub
export function findBatteryDeviceWeekList(params) {
  return request({
    url: 'v3/report/findBatteryDeviceWeekList',
    method: 'post',
    data: params
  })
}
// 周报列表--lithium
export function findLithiumDeviceWeekList(params) {
  return request({
    url: 'v3/report/findLithiumDeviceWeekList',
    method: 'post',
    data: params
  })
}
